module.exports = "<ng-template lfwmsDynamicWidget></ng-template>\n"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/components/widget/dynamic-widget-holder/dynamic-widget-holder.component.html
// module id = ../../../../../src/app/shared/components/widget/dynamic-widget-holder/dynamic-widget-holder.component.html
// module chunks = main